import axios from 'axios';
import React, { useEffect, useState, useCallback } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';

import { Config } from '../../common/config';
import AlertModal from '../../components/alertModal';
import LeftMenu from '../../components/leftMenu';
import { getErrorMessage } from '../../components/utils';
import useStoreNo from '../../hooks/useStoreNo';

export default function QnaContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const receivedData = location.state;
  const qnaNo = receivedData?.qnaNo;
  const [data, setData] = useState([]);
  const [modalInfo, setModalInfo] = useState({
    isCancel: true,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '삭제하시겠습니까?',
    action: '',
    isPercent: false,
  });
  const [modalOpen, setModalOpen] = useState(false);
  const storeNo = useStoreNo();
  const getData = useCallback(async _unused => {
    try {
      const ret = await axios.get(Config.API_SERVER + `qna/${qnaNo}`, {
        withCredentials: true,
      });
      setData(ret.data.data);
    } catch (error) {
      // 401 handling and refresh are centralized in useAxiosFetch
      console.error('Error getData:', error);
    }
  }, [qnaNo]);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qnaNo]);

  async function deleteQNA(_unused) {
    try {
      await axios.delete(Config.API_SERVER + `qna/${qnaNo}`, {
        withCredentials: true,
      });
      navigate(`/${storeNo}/qna-list`);
    } catch (error) {
      const msg = getErrorMessage(error?.response);
      setModalInfo(prev => ({
        ...prev,
        actionFlag: error?.response?.status === 401 ? 'login' : 'api',
        mainMsg: error?.response?.status === 401 ? '유효기간이 만료되었으니 다시 로그인해주세요' : msg,
      }));
      setModalOpen(true);
      console.error('Error deleteQNA:', error);
    }
  }
  const openModal = () => {
    setModalOpen(true);
    setModalInfo({ ...modalInfo, actionFlag: 'del' });
  };
  const closeModal = () => {
    setModalOpen(false);
  };
  const doModal = () => {
    setModalOpen(false);
    if (modalInfo.actionFlag === 'login') {
      navigate('/login');
    } else {
      deleteQNA();
    }
  };

  

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.mainMsg}
      </AlertModal>
      <section className="location_box location_box_mypage">
        <ul className="location_001">
          <li>
            <NavLink to={storeNo ? `/${storeNo}/gift-list` : '/gift-list'}>
              홈
            </NavLink>
          </li>
          <li>
            <NavLink to={storeNo ? `/${storeNo}/qna-list` : '/qna-list'}>
              서비스 문의
            </NavLink>
          </li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_mypage">
          <LeftMenu pageName="qna" />

          <section className="rightcontant_box">
            <h2 className="tit_01">서비스 문의</h2>

            <article className="contants_box_03">
              <table className="member_box">
                <tbody>
                  <tr>
                    <th>구분</th>
                    <td>{data ? data.qnaCategoryeDesc : ' '}</td>
                  </tr>
                  <tr>
                    <th>작성자</th>
                    <td>{data ? data.userId : ' '}</td>
                  </tr>
                  <tr>
                    <th>제목</th>
                    <td>{data ? data.title : ' '}</td>
                  </tr>
                  <tr>
                    <th>내용</th>
                    <td>
                      <div className="table_05">
                        {data ? data.qContent : ' '}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>답변</th>
                    <td>
                      <div className="table_05">
                        {data ? data.aContent : ' '}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>파일 다운로드</th>
                    <td>{data ? data.fileUrl : ' '}</td>
                  </tr>
                  <tr>
                    <th>공개유형</th>
                    <td>{data.noticeYn === 'Y' ? '공개' : '비공개'}</td>
                  </tr>
                </tbody>
              </table>
            </article>

            <article className="button_box_01">
              <NavLink to={`/${storeNo}/qna-list`}>
                <button
                  type="button"
                  className="button_01 button_03 button_gray_line"
                >
                  목록
                </button>
              </NavLink>

              <button
                type="button"
                onClick={() =>
                  navigate(`/${storeNo}/qna-modify`, {
                    state: { qnaNo: qnaNo },
                  })
                }
                className="button_01 button_03 button_red"
              >
                수정
              </button>

              <button
                type="button"
                onClick={openModal}
                className="button_01 button_03 button_gray_line font_red"
              >
                삭제
              </button>
            </article>
          </section>
        </section>
      </main>
    </>
  );
}
